<sc-flex class="structure-selection-field" [formGroup]="detailsFormGroup">
    <mat-form-field class="value-field" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.details.dialog.stationName"></sc-dictionary-label>
        </mat-label>
        <input matInput formControlName="value"/>
    </mat-form-field>
    <sc-content-spacer></sc-content-spacer>
    <button mat-icon-button (click)="doSelection()">
        <sc-icon iconClass="fa-sitemap"></sc-icon>
    </button>
</sc-flex>
